/* HESED Header — scroll state + mobile drawer */
(function () {
  'use strict';

  const SCROLL_THRESHOLD = 60;

  function initHeader() {
    const wrap = document.querySelector('.hesed-header-wrap');
    if (!wrap) return;

    const isHomePage = document.body.classList.contains('template-index');

    // Scroll state toggle — on non-home pages, always stay in scrolled state
    let ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          const shouldScroll = isHomePage ? window.scrollY > SCROLL_THRESHOLD : true;
          wrap.classList.toggle('is-scrolled', shouldScroll);
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load

    // Mobile drawer
    const burgerBtn  = document.querySelector('.hesed-header__burger');
    const drawer     = document.querySelector('.hesed-mobile-drawer');
    const overlay    = document.querySelector('.hesed-mobile-drawer__overlay');
    const closeBtn   = document.querySelector('.hesed-mobile-drawer__close');

    const annBar = document.querySelector('.hesed-ann-section');

    // Move drawer to <body> so position:fixed is always viewport-relative,
    // escaping any parent stacking context that would block z-index comparison.
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    function openDrawer() {
      drawer?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (annBar) annBar.style.zIndex = '100';
    }
    function closeDrawer() {
      drawer?.classList.remove('is-open');
      document.body.style.overflow = '';
      if (annBar) annBar.style.zIndex = '';
    }

    burgerBtn?.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    // Mega-menu thumbnail swap on link hover
    const megaMenus = document.querySelectorAll('.hesed-megamenu');
    megaMenus.forEach((menu) => {
      const thumb    = menu.querySelector('.hesed-megamenu__thumb img');
      const thumbLbl = menu.querySelector('.hesed-megamenu__thumb-label');
      if (!thumb) return;

      const links = menu.querySelectorAll('.hesed-megamenu__link[data-thumb]');
      links.forEach((link) => {
        link.addEventListener('mouseenter', () => {
          const src   = link.dataset.thumb;
          const label = link.dataset.thumbLabel || link.textContent.trim();
          if (src) { thumb.src = src; }
          if (thumbLbl) { thumbLbl.textContent = label; }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();
